var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoloLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 24.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fec618;\n      }\n\n      .st1 {\n        isolation: isolate;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        fill: #fec514;\n      }\n\n      .st4 {\n        fill: #152e5f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1949.3,407.3h-24.7v25.7h-16.5v-87.4c13.7,0,27.5-.1,41.2-.1,42.7,0,42.8,61.8,0,61.8ZM-1974.1,392.2h24.7c21.1,0,21-31,0-31h-24.7v31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1820.2,389.8c-.2,22.6-14.1,45.2-44.8,45.2s-45-22.1-45-45.1,14.7-46.1,45-46.1,45.1,23.1,44.8,46ZM-1893.8,390.2c.4,14.4,8.1,29.7,28.7,29.7s28.4-15.5,28.6-29.8c.2-14.7-8-31.2-28.6-31.2s-29.1,16.6-28.7,31.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1791.6,345.6v72.2h45v15.2h-61.4v-87.4h16.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1651.7,389.8c-.2,22.6-14.1,45.2-44.8,45.2s-45-22.1-45-45.1,14.7-46.1,45-46.1,45.1,23.1,44.8,46ZM-1725.3,390.2c.4,14.4,8.1,29.7,28.7,29.7s28.4-15.5,28.6-29.8c.2-14.7-8-31.2-28.6-31.2s-29.1,16.6-28.7,31.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1555,345.6h18.1v.7l-29.6,42.5,30.5,43.7v.5h-18.5l-22.4-32.8-22.4,32.8h-18.5v-.5l30.3-43.7-29.5-42.5v-.7h18.1l21.9,32.6,21.9-32.6Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-1714.3 96.4 -1651.3 96.4 -1875.3 296.8 -1714.3 96.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-1770.3 224.3 -1710.2 297.3 -1651.5 297.3 -1736.5 194 -1770.3 224.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-1775.4 147.1 -1816.3 96.4 -1875.1 96.5 -1804.5 183.2 -1775.4 147.1"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2.9,21.3h-1.6v1.7H.2v-5.7c.9,0,1.8,0,2.7,0,2.8,0,2.8,4,0,4ZM1.3,20.4h1.6c1.4,0,1.4-2,0-2h-1.6v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M11.3,20.2c0,1.5-.9,2.9-2.9,2.9s-2.9-1.4-2.9-2.9,1-3,2.9-3,2.9,1.5,2.9,3ZM6.5,20.2c0,.9.5,1.9,1.9,1.9s1.8-1,1.9-1.9c0-1-.5-2-1.9-2s-1.9,1.1-1.9,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M13.2,17.3v4.7h2.9v1h-4v-5.7h1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.3,20.2c0,1.5-.9,2.9-2.9,2.9s-2.9-1.4-2.9-2.9,1-3,2.9-3,2.9,1.5,2.9,3ZM17.5,20.2c0,.9.5,1.9,1.9,1.9s1.8-1,1.9-1.9c0-1-.5-2-1.9-2s-1.9,1.1-1.9,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M28.6,17.3h1.2s-1.9,2.8-1.9,2.8l2,2.8h0s-1.2,0-1.2,0l-1.5-2.1-1.5,2.1h-1.2s2-2.9,2-2.9l-1.9-2.8h0s1.2,0,1.2,0l1.4,2.1,1.4-2.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.2 1.1 22.3 1.1 7.7 14.1 18.2 1.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "14.6 9.4 18.5 14.2 22.3 14.2 16.8 7.5 14.6 9.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "14.2 4.4 11.6 1.1 7.8 1.1 12.3 6.8 14.2 4.4"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-1215.3-449l-171.4,63.7c-32.3,12-66.6-11.9-66.6-46.3v-127.4c0-34.5,34.4-58.3,66.6-46.3l171.4,63.7c42.9,16,42.9,76.7,0,92.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-1232.5-536.5l-20.5,49.1v39.6h-17.1v-39.6l-20.5-49.1h17.1l11.9,32.2,11.9-32.2h17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-1371.2-523.7v24.8c0,7.2-5.8,13-13,13h-28v37.8h-17v-88.6h45c7.2,0,13,5.8,13,13ZM-1388.3-518.8h-23.9v15.6h23.9v-15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-1717.5-523.7v24.8c0,7.2-5.8,13-13,13h-28v37.8h-17v-88.6h45c7.2,0,13,5.8,13,13ZM-1734.6-518.8h-23.9v15.6h23.9v-15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-1652.1-536.4h-32.5c-6.3,0-11.4,5.1-11.4,11.4v65.8c0,6.3,5.1,11.4,11.4,11.4h32.5c6.3,0,11.4-5.1,11.4-11.4v-65.8c0-6.3-5.1-11.4-11.4-11.4ZM-1656.7-464.2h-22.5v-55.6h22.5v55.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-1506.3-536.4h-32.5c-6.3,0-11.4,5.1-11.4,11.4v65.8c0,6.3,5.1,11.4,11.4,11.4h32.5c6.3,0,11.4-5.1,11.4-11.4v-65.8c0-6.3-5.1-11.4-11.4-11.4ZM-1510.8-464.2h-22.5v-55.6h22.5v55.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-1604.1-464.3h28.6l4.2,16.2h-37.1c-6.3,0-11.4-5.1-11.4-11.4v-76.5h15.9v71.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-1302.1-525.9v77.1h-18.9v-30.9h-17.8v30.9h-18.8v-77.1c0-6.3,5.1-11.5,11.5-11.5h32.6c6.3,0,11.5,5.1,11.5,11.5ZM-1338.8-493.9h17.8v-28.4h-17.8v28.4Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoloLogo);
export default __webpack_public_path__ + "static/media/polo-logo.69c83a682c90d47197d81393628df241.svg";
export { ForwardRef as ReactComponent };